import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class InputType extends BaseOption {
  static label = "Input Type";

  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        { id: "text", name: "Text" },
        { id: "email", name: "Email" },
        { id: "tel", name: "Phone" },
        { id: "url", name: "Web address" },
        { id: "search", name: "Search" },
      ],
    },
  };

  static defaultValue = "text";
}
